import React from "react";
import { Container, Button } from "react-bootstrap";
import "./banner.css";
import Image from "../../assets/sharpgunBanner.png";

const Banner = () => {
  return (
    <>
      <div className="bg-light text-center banner">
        <Container>
          <img
            src={Image}
            alt="Time"
            className="banner-margin"
          />
        </Container>
      </div>
    </>
  );
};

export default Banner;
